import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import get from 'lodash-es/get';
import isArray from 'lodash-es/isArray';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Icon from '@panneau/element-icon';

var propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  itemLabelPath: PropTypes.string,
  itemClassName: PropTypes.string,
  itemClassNamePath: PropTypes.string
};
var defaultProps = {
  value: null,
  placeholder: null,
  itemLabelPath: 'label',
  itemIconPath: null,
  itemClassName: 'bg-secondary',
  itemClassNamePath: null
};
var Badges = function Badges(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    itemLabelPath = _ref.itemLabelPath,
    itemIconPath = _ref.itemIconPath,
    itemClassName = _ref.itemClassName,
    itemClassNamePath = _ref.itemClassNamePath;
  var items = useMemo(function () {
    return (isArray(value) ? value : [value]).filter(function (it) {
      return it !== null;
    }) || [];
  }, [value]);
  return items.map(function (it) {
    var label = get(it, itemLabelPath, null);
    var icon = get(it, itemIconPath, null);
    var className = get(it, itemClassNamePath, null);
    return label !== null || icon !== null ? /*#__PURE__*/React.createElement("span", {
      className: classNames(['badge', 'mb-1', 'me-1', _defineProperty(_defineProperty({}, itemClassName, itemClassName !== null), className, className !== null)])
    }, icon !== null ? /*#__PURE__*/React.createElement(Icon, {
      name: icon
    }) : label) : placeholder;
  });
};
Badges.propTypes = propTypes;
Badges.defaultProps = defaultProps;

export { Badges as default };
